import { isTouchDevice } from "./device-detection";

const TAG_LINE = "Locally Owned and Operated";
export function localizationTagLine(){
    const tagLine = document.querySelector('.header-wrapper .description')as HTMLSpanElement;
    const dbaName = localStorage.getItem('dbaName');
    //replace the tage line even if the page is national provided the user is localized
    const existingTagLine = localStorage.getItem('localTagLine') ?? TAG_LINE;
    if(dbaName && existingTagLine && tagLine){
        tagLine.textContent = existingTagLine ?? TAG_LINE;
    }

}

export function localizationMobileDBATitle(){
    if (!isTouchDevice()) return;

    const sessionBrandData = sessionStorage.getItem('brandDetails');
    const brandData = sessionBrandData ? JSON.parse(sessionBrandData) : {};
        
    const localDBAMobileHeader = document.querySelector(".local-owned.mobile-only") as HTMLDivElement;

    if (localDBAMobileHeader && !brandData?.disable_mobile_dba_os_flow) {
        updateDBAInfo(localDBAMobileHeader);
    }
}

function updateDBAInfo(header: HTMLDivElement) {
    const dbaName = localStorage.getItem("doingBusinessAs");
    const franchiseWebLocationId = localStorage.getItem("franchiseWebLocationId");
    if (franchiseWebLocationId && dbaName) {
        header.classList.remove('hidden');
        
        const localTitle = header.querySelector('.local-title');
        const localTagLine = header.querySelector('.local-subtitle');
        if (localTitle) {
            header.style.backgroundColor = "rgb(255 255 255)";
            localTitle.textContent = dbaName;
        }
        if (localTagLine) {
            localTagLine.textContent = localStorage.getItem('localTagLine') ?? TAG_LINE;
        }
    }
}

export function localizationTagUpadation(){
    const localTagLine = localStorage.getItem('localTagLine')
    if(localStorage.getItem('dbaName')){
        let replaceText = localTagLine ?? TAG_LINE ;
        localStorage.setItem('localTagLine', replaceText);
    }
}